import { Routes, Route } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { FiardleGamePage } from './FiardleGamePage';
import { FiardleStatsPage } from './FiardleStatsPage';

export function FiardleArchePage() {
  return (
    <ArcheLayout>
      <Routes>
        <Route path="/" element={<FiardleGamePage />} />
        <Route path="/stats" element={<FiardleStatsPage />} />
      </Routes>
    </ArcheLayout>
  );
}
